var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0.0749512C24.866 0.0749512 28 3.20896 28 7.07495L28 29.9062L30.5119 27.3672C33.2309 24.6189 37.6392 24.6189 40.3582 27.3672C43.0772 30.1155 43.0772 34.5713 40.3582 37.3196L26.9232 50.8994C25.3643 52.475 23.2502 53.1473 21.2175 52.9163C19.1848 53.1473 17.0707 52.475 15.5119 50.8994L2.07683 37.3196C-0.642148 34.5713 -0.642148 30.1155 2.07683 27.3672C4.79582 24.6189 9.20416 24.6189 11.9231 27.3672L14 29.4664L14 7.07495C14 3.20896 17.134 0.0749512 21 0.0749512Z",
    fill: "url(#arrow_loan_gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow_loan_gradient",
    x1: 21.2175,
    y1: -0.933643,
    x2: 21.2175,
    y2: 52.9606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF8E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLoan);
export default __webpack_public_path__ + "static/media/arrow-loan.f9c76e070f9d9a7fa4fcca16e69334bf.svg";
export { ForwardRef as ReactComponent };